import React, { useState, useRef, useEffect } from 'react';

import CreateTrade from '../context_menu/CreateTrade';


import {RiArrowDropDownLine, RiArrowDropUpLine} from "react-icons/ri"


function MobilePosition(props) {
    const coin = props.coin
    const position = props.position
    const exchange = props.exchange
    const side = props.side
    const coinName = props.coinName
    const coinNumber = props.coinNumber 
   
    const size = side === "Sell" ? -Math.abs(position.size) : position.size;
    const prefix = props.prefix
    const avgPrice = props.avgPrice


  
  const [selectedTab, setSelectedTab] = useState("create_trade")
  const [show, setShow] = useState()

  function formatNumber(value, maxDecimals) {
    const num = Number(value);
    if (isNaN(num)) return value;
  
    const rounded = Number(num.toFixed(maxDecimals));
    return rounded.toString();
  }


  return (
    <li className='li'>
    <div className="position_container line_hover no_drag" key={exchange+"_"+coin} onClick={()=> setShow(!show)}>
      <div className={side === "Sell" ? "temoin sell" : "temoin buy"}></div>
      <div className="cell cell_instrument position_instrument" id={coin}>{prefix}{coinName}</div>
      <div className={side === "Sell" ? "cell position_qty sell_text" : "cell position_qty buy_text"}>{size}</div>
      {/* <div className="cell position_value">{position.positionValue}</div>
      <div className="cell position_value">{position.avgPrice}</div>
      <div className="cell position_pnl">{position.unrealisedPnl}</div> */}
      <div className="cell position_value">
        {formatNumber(position.positionValue, 2)}
      </div>
      <div className="cell position_value">
        {formatNumber(position.avgPrice, 6)}
      </div>
      <div className="cell position_pnl">
        {formatNumber(position.unrealisedPnl, 2)}
      </div>
      {show  ? (<span className="state_span click"  ><RiArrowDropUpLine size={15}/> </span>):
        (<span className="state_span click"  ><RiArrowDropDownLine size={15}/> </span>)}
    </div>
    
    <div className={show ? "position_stop_options show_position" : "position_stop_options"}>
      <ul className="context_menu no_drag"  >
        <li className={selectedTab === "create_trade" ? "li active_tab ": "li tab"} onClick={()=> setSelectedTab("create_trade")}>Create Position Trade</li>
        {/* <li className={selectedTab === "test" ? "li active_tab": "li tab"} onClick={()=> setSelectedTab("test")}>Test Option</li> */}
      </ul>
      { renderTabContent(selectedTab, avgPrice, coin, position, size, exchange, side, coinName, coinNumber, prefix, setShow, show)}
    </div>


  </li>
  )
}

export default MobilePosition

function renderTabContent(selectedTab, avgPrice, coin, position, size, exchange, side, coinName, coinNumber, prefix, setShow, show) {
  console.log('POSITIONS', side, size)
    switch (selectedTab) {
        case 'create_trade':
            return <CreateTrade setShow={setShow} show={show} avgPrice={avgPrice} coin={coin} position={position} size={size} exchange={exchange} side={side} coinName={coinName} coinNumber={coinNumber} prefix={prefix}/>;
        
    }
  }



  {/* {modalData && (
<div className="modal_overlay no_drag">
  <div className="modal">
    <h3 className='modal_option_title'>{modalData.option.replaceAll('_', ' ')}</h3>
    <h4 className='modal_coin_name'><span className='exchange_name_title'>{modalData.exchange}</span> {modalData.coinName}: <span className="position_quantity">{modalData.size}</span></h4>
    <form className='modal_form_container' onSubmit={handleSubmit}>
        <div className="create_trade_input_container">
          <h3 className='modal_input_title'>Quantity  </h3>
           <input className="input modal_input"  value={percentage === 100 ? modalData.size : createTradeQuantity} onChange={(e) => handleQuantityChange(e)}/>
        </div>
        <div className="create_trade_input_container">
          <input type="range" id="percentage-slider" name="percentage" min="1" max="100" value={percentage} onChange={handleSliderChange} className="slider"/>
          <span className="percentage_display">{percentage}%</span>
          
        </div>
        <div className="create_trade_input_container">
        <ul className="percent_button_container">
            <li className="percent_button li"  onClick={()=> handlePercentChange(25)}>25%</li>
            <li className="percent_button li"  onClick={()=> handlePercentChange(50)}>50%</li>
            <li className="percent_button li" onClick={()=> handlePercentChange(75)}>75%</li>
            <li className="percent_button li" onClick={()=> handlePercentChange(100)}>100%</li>
          </ul>
        </div>
        {stop_input_list.map((input, i) => 
          <div className="create_trade_input_container">
            <h3 className="modal_input_title">{input.replaceAll("_", " ")}</h3>
            <input  className="input modal_input" value={filledStopInput[input] || ""} name={input} onChange={(e)=> handleStopInputChange(e)} />
          </div>
        )}
        <div className="settings_list_container">
          <h3 className='modal_input_title'>Stop Settings</h3>
          <ul className=" form_radio_container">
          {Object.keys(settings).map(function(setting) {
                  return(
                  <li className={selectedSetting["setting_name"] === setting ? "li li_setting active_li_setting no_drag" : "li li_setting no_drag"}  key={setting}>
                      <p key={setting+"input"} className="no_drag setting_name" onClick={() => selectSetting(setting)}>{setting.replaceAll('_', ' ')}</p>
                     {selectedSetting["setting_name"] === setting ? <IoMdCloseCircle className="no_drag close_selected_setting" onClick={() => clearSelectedSetting(setting)}/> : null}
                </li>)
              })
          }  
          </ul>
      </div>
        <div className="accordion accordion_positions" id="trade_stop_settings">
          {Object.keys(accordion2).map(function(option, i) {
              return(
                  <div className='item' key={"item" +i}>
                      <div className="title no_drag" key={"title" + i} onClick={() => toggleAccordion(option)}>
                          <h3 key={"h3_" +i}>{option}</h3>
                          <span key={"span_" +i}>{selectedAccordion === option ? "-" : "+"}</span>

                    </div>
                    {data_accordion[option].map((item, j) => 
                    
                    <div key={"content2_trade" +j} className={selectedAccordion === option ? "content show" : "content"}>
                        <p className="accordion_p" key={"p" +j}>{item.replaceAll('_', ' ')}</p>
                        <input key={"input_" +j} className="input no_drag" name={item} id={option} value={stopSettings[item] || ''} onChange={(e) => handleStopChange(e)} type="text" />
                        
                        
                    </div>
                    )}
                  </div>
                )
            })}
        </div>

     
      <button className="btn modal_submit" type="submit">Create</button>
      
    </form>

    <AiOutlineClose className="close_modal" onClick={()=> closeModal()}/>
  </div>
</div>
)} */}
    {/* <div className="mobile_context_menu">
    <ul className="widget_tab_nav">
      <li className={selectedTab === "create_trade" ? "active_widget_tab li no_drag": "li no_drag"} onClick={()=> setSelectedTab("create_trade")}>Create Trade</li>
     
    </ul>
    { renderTabContent(selectedTab)}
    </div> */}